// removed by extract-text-webpack-plugin
module.exports = {"footer":"_2uuI9divykC6A9Zkt0VTxx","textContainer":"_3xcLe0h7IuOVZfaS7_a_Pj"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Footer/Footer.less
// module id = 747
// module chunks = 0